import axios from 'axios'

// eslint-disable-next-line import/no-internal-modules
import { DataSourceOpts, DataSourceResponse } from '@insided/deprecated-control/overview'

import { SegmentData } from './types'

export const fetchData = async ({ pagination }: DataSourceOpts): Promise<DataSourceResponse<SegmentData>> => {
  const queryParams: {
    page: number
    size: number
  } = {
    page: pagination.page,
    size: pagination.pageSize
  }

  const response = await axios.get('/users/segments/segments', {
    params: queryParams
  })

  return {
    data: response.data.items,
    total: response.data.totalItems
  }
}
